import apiService from "../../ApiService";

export declare type BoostFormData = {
  sourceIp: string;
  destinationCidr: string;
  destinationPort: number;
  webrtcMode?: "host" | "relay";
};
export const boostSubscribe = (data: BoostFormData) => {
  return apiService.post<unknown>({
    path: `v1/store/ericsson/boost`,
    body: data,
  });
};
